import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowLeft, Mail, Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";

const LockedContainer = () => {
  const { qr } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const ownerName = location.state?.owner_name || "the owner";
  const householdName = location.state?.household_name;

  const copyCode = () => {
    navigator.clipboard?.writeText(qr || "");
    toast.success("QR code copied");
  };

  return (
    <div className="px-5 pt-6 pb-10">
      <button
        onClick={() => navigate(-1)}
        data-testid="locked-back-btn"
        className="text-sm text-[#4F5D75] hover:text-[#2D3142] flex items-center gap-2 mb-6"
      >
        <ArrowLeft className="w-4 h-4" /> Back
      </button>

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="tup-card p-7 text-center"
        data-testid="locked-card"
      >
        <div className="w-16 h-16 mx-auto rounded-2xl brand-gradient-bg flex items-center justify-center shadow-lg shadow-[#1F5566]/20">
          <Lock className="w-7 h-7 text-white" />
        </div>

        <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#277A82] mt-6">
          Private Q-Box
        </div>
        <h1 className="font-heading text-3xl font-bold text-[#2D3142] mt-1 leading-tight">
          This Q-Box is private
        </h1>
        <p className="text-[#4F5D75] mt-3 leading-relaxed">
          <span className="font-semibold text-[#2D3142]">{ownerName}</span>
          {householdName ? <> from <span className="font-semibold">{householdName}</span></> : null}{" "}
          hasn't shared this container with you. Ask them for access.
        </p>

        <div className="mt-6 tup-card p-4 bg-[#F5F3ED] text-left" data-testid="locked-qr">
          <div className="text-[11px] uppercase tracking-[0.18em] font-bold text-[#8A93A6]">
            QR code
          </div>
          <div className="flex items-center justify-between gap-2 mt-1.5">
            <div className="font-mono text-base text-[#2D3142] tracking-wider truncate">
              {qr}
            </div>
            <button
              onClick={copyCode}
              data-testid="locked-copy-btn"
              className="shrink-0 text-[#277A82] hover:bg-[#DCEDF0] rounded-lg p-2"
              aria-label="Copy code"
            >
              <Copy className="w-4 h-4" />
            </button>
          </div>
        </div>

        <p className="text-xs text-[#8A93A6] mt-5 leading-relaxed">
          Send this code to {ownerName} so they can add you as an editor in their
          container's Sharing settings.
        </p>

        <Button
          onClick={() => navigate("/")}
          data-testid="locked-home-btn"
          className="w-full mt-6 brand-gradient-bg text-white h-12 hover:opacity-90"
        >
          <Mail className="w-4 h-4 mr-2" /> Back to my fridge
        </Button>
      </motion.div>
    </div>
  );
};

export default LockedContainer;
